var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.229L1.979 11.25C1.81233 11.4167 1.611 11.4967 1.375 11.49C1.139 11.4827 0.937664 11.3957 0.770997 11.229C0.604331 11.0623 0.520997 10.8577 0.520997 10.615C0.520997 10.3717 0.604331 10.1667 0.770997 10L4.771 6L0.749997 1.979C0.583331 1.81233 0.503331 1.60767 0.509998 1.365C0.517331 1.12167 0.604331 0.916667 0.770997 0.75C0.937664 0.583333 1.14233 0.5 1.385 0.5C1.62833 0.5 1.83333 0.583333 2 0.75L6 4.771L10.021 0.75C10.1877 0.583333 10.3923 0.5 10.635 0.5C10.8783 0.5 11.0833 0.583333 11.25 0.75C11.4167 0.916667 11.5 1.12167 11.5 1.365C11.5 1.60767 11.4167 1.81233 11.25 1.979L7.229 6L11.25 10.021C11.4167 10.1877 11.5 10.389 11.5 10.625C11.5 10.861 11.4167 11.0623 11.25 11.229C11.0833 11.3957 10.8783 11.479 10.635 11.479C10.3923 11.479 10.1877 11.3957 10.021 11.229L6 7.229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/closeWhite.22c98419b429e8758b27423dcf27f6ea.svg";
export { ForwardRef as ReactComponent };